
export default [
  {
    name: 'simul',
    path: '/simul',
    meta: { layout: 'EmptyLayout' },
    component: require('@/pages/simul/WeverseSimul.vue').default,
  },
]
